import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import InstancesInstructor from './InstancesInstructor';
import InstancesAdmin from './InstancesAdmin';
import InstancesOnBehalf from "./InstancesOnBehalf";

const InstancesSecr = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_e, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <AppBar position="static">
        <Tabs variant="fullWidth" value={tab} onChange={handleTabChange}>
          <Tab label="Solicitudes" />
          <Tab label="Instancias" />
          <Tab label="Crear solicitud" />
        </Tabs>
      </AppBar>
      <div className="tfg">
        { tab === 0 && <InstancesInstructor secr /> }
        { tab === 1 && <InstancesAdmin secr /> }
        { tab === 2 && <InstancesOnBehalf /> }
      </div>
    </>
  );
};

export default InstancesSecr;
